$(document).ready(function() {
  
$('.slider-for1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    asNavFor: '.slider-nav1'
  });

  $('.slider-nav1').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for1',
    dots: false,
    focusOnSelect: true, 
    prevArrow: '<button type="button" class="slick-prev">‹</button>',
    nextArrow: '<button type="button" class="slick-next">›</button>',
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
	

  $('.reviewSlider').slick({
    slidesToShow: 2,
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.brandSlider').slick({
    slidesToShow: 6,
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });


    // Tab collection
  setTimeout(function(){
    $('.tab_content .product-list').slick({
      arrows: true,
      infinite: true,
      slidesToShow: 4, 
      slidesToScroll: 1, 
      arrows: true, 
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }
      ],
    });
  },500);
  
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  
    $('.tab_content .product-list').slick('refresh');
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    
    $('.tab_content .product-list').slick('refresh');
  });
  
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");


 $(".moreLink").click(function(e) {
    e.preventDefault();
    var $this = $(this);
    var $extraContent = $this.prev(".extra-content");
    
    if ($extraContent.is(":visible")) {
       $extraContent.slideUp();
       $this.text("Read more");
    } else {
       $extraContent.slideDown();
       $this.text("Read less");
    }
 });

  
});

$(document).on("click", ".js-custom-add-to-cart", function (event) {
  event.preventDefault(); // Prevent the default form submission
 let addToCartForm = document.querySelector('form[action$="/cart/add"]');
  let formData = new FormData(addToCartForm);
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
});

// Related Products Slider PDP
setTimeout(function () {
    var $slider = $('.halo-row.collection-carousel');

    if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick();
    }

    $('.btn-arrow-prev').click(function () {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('slickPrev');
        }
    });

    $('.btn-arrow-next').click(function () {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('slickNext');
        }
    });
}, 1000); 

// Related Products Slider PDP





			














